//@flow
import React from 'react';
import {Hidden, makeStyles} from '@material-ui/core';

import type {Theme} from '@material-ui/core';
import TaxInvoiceFilters from './TaxInvoiceFilters';
import {
  useTaxInvoiceDocumentOrders,
  useTaxInvoiceTableFilterActions,
} from '../../utils';
import TaxInvoiceCard from '../TaxInvoiceCard';
import TaxInvoiceTable from './TaxInvoiceTable';
import {useUnMount} from '../../../../utils/react/useUnMount';
import InlineLoader from '../../../../elements/LoadingSpinner/InlineLoader';
import UsageProgressCard from '../../../feature-usage/components/UsageProgressCard';

const useStyles = makeStyles((theme: Theme) => ({
  loader: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 1,
    backgroundColor: 'rgba(255,255,255,.5)',
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    padding: '.5rem',
  },
  emptyTableLabel: {
    width: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    fontWeight: 600,
    padding: '1rem',
    pointerEvents: 'none',
  },
  usageCardContainer: {
    padding: '1rem',
    width: '100%',
  },
}));

export default function TaxInvoiceDashboard() {
  const classes = useStyles();
  const {documents, loading} = useTaxInvoiceDocumentOrders();

  const {resetTableFilters} = useTaxInvoiceTableFilterActions();

  useUnMount(resetTableFilters);

  return (
    <div className={classes.root}>
      <TaxInvoiceFilters />

      {loading && (
        <div className={classes.loader}>
          <InlineLoader loading size={45} />
        </div>
      )}

      {documents.length === 0 && !loading && (
        <div className={classes.emptyTableLabel}>Aun no tienes facturas</div>
      )}

      {documents.length > 0 && !loading && (
        <>
          <Hidden mdUp>
            <div className={classes.cardsContainer}>
              {documents.map(document => (
                <TaxInvoiceCard document={document} key={document.orderId} />
              ))}
            </div>
          </Hidden>
          <Hidden smDown>
            <TaxInvoiceTable documents={documents} />
          </Hidden>
        </>
      )}

      {documents.length !== 0 && !loading && (
        <div className={classes.usageCardContainer}>
          <UsageProgressCard feature="TAX_INVOICE" />
        </div>
      )}
    </div>
  );
}
